
import * as constants from "../../../constants";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import CommonUtilities from "../Utils/CommonUtilities";
import EntryForm from "./EntryForm";
import { useLocation } from "react-router-dom";


const CreditLinePayments = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const translate = t as (key: string) => string;
  const transactionTypes = CommonUtilities.creditLineTransactionTypes;
  const rowDetails = location.state.rowData;
  const AdminProfile = useSelector((state: RootState) => state.participantAdminProfile); 
  return (
    <EntryForm
      accountType={false}
      methodOfPayment={true}
      participantField={true}
      commentsField={true}
      typeOfTransactions={true}
      dateOfTransactions={true}
      checkReferenceField={true}
      creditLineClose={true}
      amountField={true}
      rowDetails={rowDetails}
      transactionTypes={transactionTypes}
      headingMessage={translate('creditLinePayments')}
      pageType="creditLinePayments"
      navigationPath={"/creditLineSummaryListing"}
    />
  );
};

export default CreditLinePayments;